import * as XLSX from 'xlsx';

export const exportToExcel = (consultas, practicas, tipo, fileName) => {
  const workbook = XLSX.utils.book_new();
  const fechaPresentacion = new Date().toLocaleDateString('es-AR');

  const prepararDatos = (datos) => {
    return datos
      .filter(item => item.selected !== false)
      .map(item => ({
        'Nro': item.rowNumber,
        'Nº Afiliado': item.nroAfiliado,
        'DNI': item.dni,
        'Apellido': item.apellido,
        'Nombre': item.nombre,
        'F. Estudio': item.f_Estudio,
        'Código': item.codigo,
        'Práctica': item.practica,
        'INT/DOM/AMB': item.forma,
        'Presentación': fechaPresentacion,
        'Nº Factura': item.nroFactura,
        'Gravado': item.grav,
        'Importe': item.importe,
        '10.5%': item.medioIva,
        'Copago': item.conCopago
      }));
  };

  const agregarTotales = (ws, datos) => {
    const facturables = datos.filter(item => item.selected !== false);
    const subtotal = facturables.reduce((sum, item) => sum + (item.importe || 0), 0);
    const copago = facturables.reduce((sum, item) => sum + (item.conCopago || 0), 0);
    const medioIva = facturables.reduce((sum, item) => sum + (item.medioIva || 0), 0);
    const total = subtotal + medioIva - copago;

    const range = XLSX.utils.decode_range(ws['!ref']);
    const lastRow = range.e.r + 2;

    XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '', '', '', '', '', '', '', '', 'Subtotal:', subtotal, '']], { origin: `A${lastRow + 1}` });
    XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '', '', '', '', '', '', '', '', 'Copago:', '', copago]], { origin: `A${lastRow + 2}` });
    XLSX.utils.sheet_add_aoa(ws, [['', '', '', '', '', '', '', '', '', '', '', '', '', 'Total:', total, '']], { origin: `A${lastRow + 3}` });
  };

  switch (tipo) {
    case 'general':
      if (practicas.length > 0) {
        const wsPracticas = XLSX.utils.json_to_sheet(prepararDatos(practicas));
        agregarTotales(wsPracticas, practicas);
        XLSX.utils.book_append_sheet(workbook, wsPracticas, 'Practicas');
      }
      break;
    case 'practicas':
      if (practicas.length > 0) {
        const wsP = XLSX.utils.json_to_sheet(prepararDatos(practicas));
        agregarTotales(wsP, practicas);
        XLSX.utils.book_append_sheet(workbook, wsP, 'Practicas');
      }
      break;
    default:
      break;
  }

  XLSX.writeFile(workbook, fileName);
};
